
<div class="my-5">
  <div class="container py-4">
    <h2 class="display-6 fw-bold text-center">
      20+ Creative Apps.
      Infinite Possibilities.
    </h2>

    <div class="row justify-content-center">
      <p class="mt-4 fs-5 fw-bold text-center col-12 col-xl-8">
        Designed for creative professionals, students, and educators, these
        software tools provide powerful features for graphic design, video
        editing, web development, photography, and document management.
      </p>
    </div>

    <dl class="row row-cols-lg-3 g-4 px-4 mt-4 list-style-none">
      @for (app of apps; track app.appName) {
        <div class="app-tile">
          <div class="app-icon">
            <img ngSrc="assets/images/adobe/adobe-app-icons/{{app.iconPath}}"
                 width="64"
                 height="64"
                 alt="{{app.appName}}">
          </div>
          <div>
            <dt class="">
              {{app.appName}}
            </dt>
            <dd class="mb-0">
              {{app.description}}
            </dd>
          </div>
        </div>
      }
    </dl>

  </div>
</div>
